let apiUrl = '';
const apiPort = '';
let apiPoint = '';
let socket = '';
const mqttServer = 'dtm.mqtt.spot-finder.app';
const mqttServerPort = 443;
apiUrl = `https://dtm.api.spot-finder.app`;
apiPoint = `${apiUrl}/api`;
socket = `https://dtm.socket.spot-finder.app`;

export const userTheme = {
  light: 'light',
  dark: 'dark',
};

export const LOCAL_ZONES_TYPES = {
  'DRA-I': 'DRA-I_LOCAL',
  'DRA-P': 'DRA-P_LOCAL',
  'DRA-RH': 'DRA-RH_LOCAL',
  'DRA-RM': 'DRA-RM_LOCAL',
  'DRA-RL': 'DRA-RL_LOCAL',
  'DRA-T': 'DRA-T_LOCAL',
  'DRA-U': 'DRA-U_LOCAL',
};

export const GROUP_TYPES = {
  admin: 'admin',
  org_admin: 'org_admin',
  reporter: 'reporter',
  controller: 'controller',
  reader: 'reader',
};

export const TABLE_ROWS_PER_PAGE = 25;

export const apiBase = apiPoint;
export const socketUrl = socket;
export const mqttUrl = mqttServer;
export const mqttPort = mqttServerPort;
export const refreshTokenIntervalConfig = 10 * 60 * 1000;
export const missionsApprovalsGetterInterval = 60000;
export const operationsApprovalsInterval = 10000;
export const uavoDataCardRefreshInterval = 3000;
export const tileServerUrl = option =>
  `https://dtm.tiles.spot-finder.app/${option || 'mbLight'}/{z}/{x}/{y}.png`;
